export const getRandomText = () => {
  const texts = ['Готовимся к релизу', 'Наполняем коворкинг печеньем', 'Деплоим', 'Просыпаем дедлайн', 'Питчим хакатон', 'Мокаем решение', 'Заливаем решение', 'Дебажим'];

  return texts[Math.floor(Math.random() * texts.length)];
};
